import React from 'react'
import PropTypes from 'prop-types'
import { intlMessageShape, FormattedHTMLMessage } from 'sb-react-intl'

import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import Button from 'components/buttons/Button/Button'

import s from './HeaderBanner.scss'


const HeaderBanner = ({ children, onClose, textMessage, valuesMessage, btnMessage, redirectLink, link, onClick }) => (
  <div className={s.banner}>
    <WidthContainer>
      <div className={s.content}>
        <CloseIcon className={s.closeButton} onClick={onClose} />
        {
          Boolean(textMessage) && (
            <FormattedHTMLMessage className={s.bannerText} tag="div" {...textMessage} values={valuesMessage} />
          )
        }
        {
          Boolean(btnMessage) && (
            <Button
              sm
              className={s.button}
              brand
              title={btnMessage}
              to={link}
              redirect={redirectLink}
              onClick={onClick}
            />
          )
        }
        {children}
      </div>
    </WidthContainer>
  </div>
)

HeaderBanner.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  textMessage: PropTypes.shape(intlMessageShape),
  btnMessage: PropTypes.shape(intlMessageShape),
  valuesMessage: PropTypes.object,
  redirectLink: PropTypes.string,
  link: PropTypes.string,
}

HeaderBanner.defaultProps = {
  textMessage: null,
  btnMessage: null,
}


export default HeaderBanner
